import { render, staticRenderFns } from "./TableCollapse.vue?vue&type=template&id=4991ebb8&scoped=true&"
import script from "./TableCollapse.vue?vue&type=script&lang=js&"
export * from "./TableCollapse.vue?vue&type=script&lang=js&"
import style0 from "./TableCollapse.vue?vue&type=style&index=0&id=4991ebb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4991ebb8",
  null
  
)

export default component.exports